module.exports = __webpack_public_path__ + "static/img/10.72a3af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/10.png
// module id = jwOA
// module chunks = 0